export default __webpack_public_path__ + "static/media/38.34b930f7.png";